import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { ChevronDown } from '@makyoapp/makyo-icon/icon'
import { DD, DDItem, SimpleInput } from '@makyoapp/makyo-ui'

import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useCreateColumnContext } from '@/context/CreateColumnContext'

import { useGridV2Context } from '../../contexts/GridV2Context'
import { Fld, Lbl } from './shared'
import { TableColumnDd } from './TableColumnDd'

function isFromStartOrFromEnd(rowOptions: string) {
  return rowOptions === 'from-start' || rowOptions === 'from-end'
}

const RowOptions = [
  { label: 'First Item', value: 'first' },
  { label: 'Last Item', value: 'last' },
  { label: 'Random', value: 'random' },
  { label: 'From Start', value: 'from-start' },
  { label: 'From End', value: 'from-end' },
]

export default function FieldSingleCell() {
  const { t } = useTranslation()
  const { tables } = useDbClientContext()
  const { table } = useGridV2Context()
  const { id, value, setValue } = useCreateColumnContext()

  const [openRow, setOpenRow] = useState(false)

  const tableId = value.singleCellOptions?.tblId || ''
  const colId = value.singleCellOptions?.colId || ''
  const rowOptions = value.singleCellOptions?.rowOptions || 'first'
  const row = value.singleCellOptions?.row || ''

  const shouldShowRowIdxInput = isFromStartOrFromEnd(rowOptions)

  // table options shoud exclude current table
  const tableOptions = tables.filter((t) => t.id !== table?.id)

  if (!value.singleCellOptions) return null

  return (
    <div>
      <Fld>
        <Lbl>{t('Get Value From')}</Lbl>
        <TableColumnDd
          withSearch
          id={`${id}-singlecell-table-column`}
          value={{
            table: tableId,
            column: colId,
          }}
          excludeTypes={[ColumnTypes.SingleCell]}
          options={tableOptions}
          onChange={(tableId, colId) => {
            setValue({
              ...value,
              singleCellOptions: {
                ...value.singleCellOptions,
                tblId: tableId,
                colId: colId,
              },
            })
          }}
        />
      </Fld>

      <Fld>
        <Lbl>{t('Get Row')}</Lbl>

        <DD
          id={`${id}-singlecell-row`}
          onSelect={(eventKey, e) => {
            e.preventDefault()
          }}
          show={openRow}
          className='w-full txt'
          toggleClassName='w-full txt'
          toggle={(active, toggleProps) => {
            return (
              <div className='sdd-toggle sdd-toggle-normal txt w-full' {...toggleProps}>
                <div className='w-full txt text-left'>
                  {RowOptions.find((option) => option.value === rowOptions)?.label}
                </div>
                <ChevronDown className='shrink-0' />
              </div>
            )
          }}
          onToggle={(e, meta) => {
            setOpenRow(!openRow)
          }}
          menuClassName='sdd-menu-subc z-501 overflow-x-hidden mk-ag-sdd mk-tbl-dd'
          menuNoPad
          menuWrapperClassName='w-[200px]'
          portalMenu
        >
          <div className={'mk-tbl-dd-tbl'}>
            {RowOptions.map((opt) => {
              return (
                <DDItem
                  className={clsx('sdd-item mk-tbl-item', opt.value === row && 'sdd-item-selected')}
                  key={opt.value}
                  onClick={() => {
                    setValue({
                      ...value,
                      singleCellOptions: {
                        ...value.singleCellOptions,
                        rowOptions: opt.value as any,
                        row: isFromStartOrFromEnd(opt.value) ? '1' : '',
                      },
                    })
                    setOpenRow(false)
                  }}
                >
                  <div className='txt'>{opt.label}</div>
                </DDItem>
              )
            })}
          </div>
        </DD>
      </Fld>

      {shouldShowRowIdxInput && (
        <Fld>
          <Lbl>{t('Row Index')}</Lbl>

          <SimpleInput
            type='text'
            inputClassName='min-w-0'
            value={row}
            placeholder={t('Enter Row Number')}
            onChange={(e) => {
              const val = e.currentTarget.value
              if (val === '-' || val === '') {
                setValue({
                  ...value,
                  singleCellOptions: {
                    ...value.singleCellOptions,
                    row: val.toString(),
                  },
                })
              } else {
                const numVal = Number(val)
                if (!isNaN(numVal)) {
                  setValue({
                    ...value,
                    singleCellOptions: {
                      ...value.singleCellOptions,
                      row: numVal.toString(),
                    },
                  })
                }
              }
            }}
          />
        </Fld>
      )}
    </div>
  )
}
